import React from 'react';
import { ToastContainer, toast, ToastOptions, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultOptions = {
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  transition: Bounce,
}

export type notifyType = 'deafult' | 'error' | 'info' | 'success';

export const notify = (message: string, type?: notifyType) => {
  switch(type) {
    case 'error': 
      toast.error(message, defaultOptions);
      break;
    case 'info':
      toast.info(message, defaultOptions);
      break;
    case 'success': 
      toast.success(message, defaultOptions);
      break;
    default: 
      toast(message, defaultOptions);
  } 
  
};

export const Notification: React.FC = () => {
  return <ToastContainer />;
};
